import { motion } from "framer-motion";
import { useState } from "react";
import { Bars3Icon, XMarkIcon } from "@heroicons/react/24/outline";

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);

  const menuItems = [
    { name: "Features", href: "#features" },
    { name: "Contact", href: "https://x.com/pitchpilot_ai" },
    // { name: "Blog", href: "#blog" },
    // { name: "Enterprise", href: "#enterprise" },
  ];

  return (
    <nav className="fixed w-full z-50 bg-primary/80 backdrop-blur-md">
      <div className="container-custom">
        <div className="flex items-center justify-between h-16">
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            className="flex-shrink-0"
          >
            <span className="text-2xl font-bold text-white">InsightSwarm</span>
          </motion.div>

          {/* Desktop menu */}
          <div className="hidden md:block">
            <div className="ml-10 flex items-center space-x-8">
              {menuItems.map((item) => (
                <motion.a
                  key={item.name}
                  href={item.href}
                  className="text-text-secondary hover:text-white transition-colors duration-300"
                  whileHover={{ scale: 1.05 }}
                >
                  {item.name}
                </motion.a>
              ))}
              <motion.button
                whileHover={{ scale: 1.05 }}
                className="bg-white text-black px-6 py-2 rounded-full hover:bg-gray-200 transition-all duration-300"
              >
                <a href="https://t.me/InsightSwarmbot"> Try Now</a>
              </motion.button>
            </div>
          </div>

          {/* Mobile menu button */}
          <div className="md:hidden">
            <button
              onClick={() => setIsOpen(!isOpen)}
              className="text-text-secondary hover:text-white"
            >
              {isOpen ? (
                <XMarkIcon className="h-6 w-6" />
              ) : (
                <Bars3Icon className="h-6 w-6" />
              )}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile menu */}
      {isOpen && (
        <motion.div
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          className="md:hidden bg-primary-light"
        >
          <div className="px-2 pt-2 pb-3 space-y-1">
            {menuItems.map((item) => (
              <a
                key={item.name}
                href={item.href}
                className="block px-3 py-2 text-text-secondary hover:text-white transition-colors duration-300"
                onClick={() => setIsOpen(false)}
              >
                {item.name}
              </a>
            ))}
            <a className="w-full bg-white text-black px-6 py-2 rounded-full hover:bg-gray-200 transition-all duration-300 mt-4" href="https://t.me/InsightSwarmbot">
              Try Now
            </a>
          </div>
        </motion.div>
      )}
    </nav>
  );
};

export default Navbar;
